'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sidebar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Sidebar, _Component);

  function Sidebar(props) {
    (0, _classCallCheck3.default)(this, Sidebar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Sidebar.__proto__ || (0, _getPrototypeOf2.default)(Sidebar)).call(this, props));

    _this.state = {
      fullScreen: false,
      rrssVisible: false,
      isMuted: true
    };

    return _this;
  }

  (0, _createClass3.default)(Sidebar, [{
    key: 'toggleFullScreen',
    value: function toggleFullScreen() {
      var elem = document.documentElement;

      if (!this.state.fullScreen) {
        this.enterFullscreen(elem);
      } else {
        this.exitFullscreen(elem);
      }

      this.setState({ fullScreen: !this.state.fullScreen ? true : false });
    }
  }, {
    key: 'enterFullscreen',
    value: function enterFullscreen(elem) {
      //console.log('full screen');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    }
  }, {
    key: 'exitFullscreen',
    value: function exitFullscreen(elem) {
      //console.log('normal screen');
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }, {
    key: 'toggleShare',
    value: function toggleShare() {
      this.setState({ rrssVisible: !this.state.rrssVisible ? true : false });
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute() {
      if (!this.state.isMuted) {
        this.refs.soundBg.pauseFadeOut('soundBg');
      } else {
        this.refs.soundBg.playFadeIn('soundBg');
      }

      this.setState({
        isMuted: !this.state.isMuted ? true : false
      });
    }
  }, {
    key: 'setMute',
    value: function setMute(muteOn) {
      if (muteOn && !this.state.isMuted) {
        this.refs.soundBg.pauseFadeOut('soundBg');
      } else if (!muteOn && this.state.isMuted) {
        this.refs.soundBg.playFadeIn('soundBg');
      }

      this.setState({
        isMuted: muteOn
      });
    }
  }, {
    key: 'exitTab',
    value: function exitTab() {
      this.refs.soundBg.fadeOutSound('soundBg');
      this.setState({ isMuted: true });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(ev) {
      ev.preventDefault;
    }
  }, {
    key: 'render',
    value: function render() {

      var screenSizeIcon = this.state.fullScreen ? "icon-normalscreen" : "icon-fullscreen";
      var rrssVisible = this.state.rrssVisible ? " visible" : " hidden";
      var toggleShare = this.state.rrssVisible ? " opened" : " closed";
      var toggleMute = this.state.isMuted ? "icon-sound" : "icon-mute";

      return _react2.default.createElement(
        'nav',
        { className: 'sidebar' },
        _react2.default.createElement(
          'ul',
          { className: 'actions' },
          _react2.default.createElement(
            'li',
            { className: 'screen', onClick: this.toggleFullScreen.bind(this) },
            _react2.default.createElement('i', { className: screenSizeIcon })
          ),
          _react2.default.createElement(
            'li',
            { ref: 'toggleSound', className: 'sound', onClick: this.toggleMute.bind(this) },
            _react2.default.createElement('i', { className: toggleMute })
          ),
          _react2.default.createElement(
            'li',
            { className: "share" + toggleShare, onClick: this.toggleShare.bind(this) },
            _react2.default.createElement('i', { className: 'icon-share' }),
            _react2.default.createElement(_components.RRSS, { rrssVisible: rrssVisible,
              twUrl: this.props.urlShare,
              url: this.props.urlShare,
              twText: this.props.twTxt,
              analytics: false })
          ),
          _react2.default.createElement(
            'li',
            { className: 'language', onClick: this.props.changeLanguage },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: this.props.urlNextLang, draggable: 'false', onClick: this.handleClick.bind(this) },
              this.props.nextLanguage
            )
          )
        ),
        _react2.default.createElement(_components.Sound, { loop: true, baseUrl: this.context.baseUrl, ref: 'soundBg', nameElem: 'soundBg', classElem: '', fileName: 'soundBg' })
      );
    }
  }]);
  return Sidebar;
}(_react.Component), _class.propTypes = {
  nextLanguage: _react.PropTypes.string
}, _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp);
exports.default = Sidebar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Sidebar.js
// module id = 799
// module chunks = 0